const mixin = {
  computed: {
    isChat() {
      return this.$route.path.includes("/chat/");
    },
  },
};

export default mixin;
